export default function StrokeRight() {
    return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={30} height={30} fill="none">
        <path
            fill="#F6D139"
            fillRule="evenodd"
            d="M11.293.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L16.586 9H1a1 1 0 0 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414Z"
            clipRule="evenodd"
        />
    </svg>)
}